import { useCallback, useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'

export default function usePreviewClient ({ show, content, clients }) {
  const companyName = useSelector(({ user: { hauler } }) => hauler?.name || '')
  const [formValues, setFormValues] = useState({
    clientId: null
  })
  const { clientId } = formValues
  const [previewContent, setPreviewContent] = useState(content)
  const [isClientFetching, setIsClientFetching] = useState(false)
  const requestIdRef = useRef(0)

  const selectedClient = (clients || []).find(
    (client) => String(client.id) === String(clientId)
  )

  useEffect(() => {
    setPreviewContent(content)
    if (!show) {
      requestIdRef.current += 1
      setFormValues({
        clientId: null
      })
      setIsClientFetching(false)
    }
  }, [
    show,
    content
  ])

  const clearClient = useCallback(() => {
    requestIdRef.current += 1
    setFormValues({
      clientId: null
    })
    setPreviewContent(content)
    setIsClientFetching(false)
  }, [content])

  const handleClientSelect = useCallback(
    (selection) => {
      if (!selection) {
        clearClient()
        return
      }
      const selectedId =
        typeof selection === 'object'
          ? selection.id
          : selection

      if (!selectedId) {
        clearClient()
        return
      }
      const requestId = requestIdRef.current + 1
      requestIdRef.current = requestId
      setFormValues({
        clientId: selectedId
      })
      setPreviewContent(content)
      setIsClientFetching(true)
    },
    [
      clearClient,
      content
    ]
  )

  const handleClientLoaded = useCallback(
    (
      loadedClientId,
      loadedRequestId,
      updatedContent
    ) => {
      if (loadedRequestId !== requestIdRef.current) return
      if (!clientId) return
      if (String(clientId) !== String(loadedClientId)) return
      setPreviewContent(updatedContent)
      setIsClientFetching(false)
    },
    [clientId]
  )

  const handleClientLoadingChange = useCallback((isFetching) => {
    setIsClientFetching(isFetching)
  }, [])

  return {
    clientId,
    companyName,
    requestId: requestIdRef.current,
    previewContent,
    isClientFetching,
    selectedClient,
    clearClient,
    handleClientSelect,
    handleClientLoaded,
    handleClientLoadingChange
  }
}
